"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTravelLengthOfStay = void 0;
var React = __importStar(require("react"));
var IconTravelLengthOfStay = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.2295,9.918 C12.1465,9.973 12.0515,10 11.9565,10 C11.8575,10 11.7595,9.971 11.6745,9.913 C10.1405,8.871 8.1525,5.903 8.0685,5.777 C7.9655,5.624 7.9565,5.427 8.0435,5.264 C8.1305,5.102 8.2995,5 8.4845,5 L15.4845,5 C15.6685,5 15.8375,5.102 15.9245,5.264 C16.0125,5.427 16.0025,5.624 15.9005,5.777 C15.8165,5.903 13.8255,8.874 12.2295,9.918 Z M6.9844,18.5059 L6.9844,20.9999 L16.9844,20.9999 L16.9844,18.4999 C16.9834,18.4789 16.8494,15.7939 11.9844,12.6019 C7.1194,15.7939 6.9854,18.4789 6.9844,18.5059 Z M6.9844,5.4999 C6.9854,5.5219 7.1194,8.2059 11.9844,11.3989 C16.8494,8.2059 16.9834,5.5219 16.9844,5.4939 L16.9844,2.9999 L6.9844,2.9999 L6.9844,5.4999 Z M19.4684,20.9999 C19.7454,20.9999 19.9684,21.2239 19.9684,21.4999 C19.9684,21.7769 19.7454,21.9999 19.4684,21.9999 L4.5004,21.9999 C4.2234,21.9999 4.0004,21.7769 4.0004,21.4999 C4.0004,21.2239 4.2234,20.9999 4.5004,20.9999 L5.9844,20.9999 L5.9844,18.4999 C5.9844,18.3709 6.0594,15.4279 11.0884,11.9999 C6.0594,8.5719 5.9844,5.6289 5.9844,5.4999 L5.9844,2.9999 L4.5004,2.9999 C4.2234,2.9999 4.0004,2.7769 4.0004,2.4999 C4.0004,2.2239 4.2234,1.9999 4.5004,1.9999 L19.4684,1.9999 C19.7454,1.9999 19.9684,2.2239 19.9684,2.4999 C19.9684,2.7769 19.7454,2.9999 19.4684,2.9999 L17.9844,2.9999 L17.9844,5.4999 C17.9844,5.6289 17.9094,8.5719 12.8804,11.9999 C17.9094,15.4279 17.9844,18.3709 17.9844,18.4999 L17.9844,20.9999 L19.4684,20.9999 Z" }))); };
exports.IconTravelLengthOfStay = IconTravelLengthOfStay;
exports.IconTravelLengthOfStay.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconTravelLengthOfStay;
